import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type SuccessDialogProps = {
  onClose: () => void;
};

export default function SuccessDialog({ onClose }: SuccessDialogProps) {
  return (
    <DefaultDialog
      disableEscapeKeyDown
      variant="success"
      confirmLabel="Continue"
      title="Service in progress"
      message="We'll notify you when your case is ready. This can take a few minutes to process."
      onConfirm={onClose}
      onClose={onClose}
    />
  );
}
